var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"head-text"},[_vm._v("Посмотрите на летательные аппараты будущего, которые были собраны другими посетителями музея.")])}
var staticRenderFns = []

export { render, staticRenderFns }